<template>
  <div class="wys_container">
    <p class="m_box">您的手机号{{ errorPhone }}已注册友邻平台</p>
    <!-- <p class="m_box"><span>请将此页面截图发给班主任,</span>申请合并账号。</p> -->
    <ul class="list">
      <li class="list_item" v-for="(item, index) in list" :key="index">
        <div class="flexbox item_top">
          <img :src="item.avatarUrl" alt="" />
          <div class="user" :class="index === 0 ? '' : 'no_user'">
            <h3>{{ item.nickName || '' }}</h3>
            <div class="info info_weight">友邻少年ID：{{ item.userId }}</div>
            <div class="info" v-if="item.bindWx">微信号：{{ item.bindWx }}</div>
            <div class="info">注册时间：{{ item.registDate }}</div>
          </div>
        </div>
        <div class="flexbox cell_title">
          {{ item.vipName }}
          <span v-if="item.vipEndDate">（截止{{ item.vipEndDate }}）</span>
          <div class="flexbox" @click.stop="showInfo(item, index)">
            详情
            <img :src="item.checked ? down_icon : right_icon" alt="" />
          </div>
        </div>
        <div class="cell" v-show="item.checked">
          <p>
            1.会员权益：{{ item.vipName }}
            <span v-if="item.vipStartDate">（{{ item.vipStartDate }}-{{ item.vipEndDate }}）</span>
          </p>
          <p>2.课程权益：{{ item.coursePrivilegeCount }}项</p>
          <p>3.总学习时长：{{ item.learnTimeMin }}分钟</p>
          <p>4.账户{{ integralName }}余额：{{ item.creditAvailable || 0 }}</p>
        </div>
      </li>
    </ul>
    <div class="flexbox adviser_box">
      <div class="flexbox img_box">
        <img :src="acountInfo.adviserErCode" alt="" />
      </div>
      <div class="text" v-if="!isNative">长按扫码添加班主任微信</div>
      <div class="text" v-else @click="nativeGoMini($event)">点击添加班主任</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import copyText from '@/utils/clipboard'
import { $gotoMiniProgram } from '@/utils/common/native-api'
import { integralName } from '@/pages/config'
export default {
  data() {
    return {
      integralName,
      right_icon: require('../../../images/merge/right_findorder.png'),
      down_icon: require('../../../images/merge/down.png'),
      isIos: false
    }
  },
  computed: {
    ...mapGetters('args', ['changeCode']),
    ...mapGetters('acount', ['list', 'acountInfo', 'errorPhone', 'isNative', 'aAccount'])
  },
  created() {
    console.log(this.isNative)
    var ua = navigator.userAgent.toLowerCase()
    this.isIos = /ipad|iPhone|Mac/i.test(ua)
  },

  methods: {
    showInfo(item, index) {
      const checked = item.checked || false
      item.checked = !checked
      this.list.splice(index, 1, item)
      console.log(this.list)
    },
    copyCode(event) {
      copyText(this.acountInfo.changeCode, event)
    },
    nativeGoMini(event) {
      const { aAccount } = this.acountInfo
      this.copyCode(event)
      this.$store.dispatch('user/login/getMiniParam', {}).then(mini => {
        $gotoMiniProgram({
          miniUserName: mini.miniUserName,
          goMiniUrl:
            'pages/rights_receive/app_add_headTeacher/app_add_headTeacher?userId=' +
            (!this.isIos ? '' : '?userId=' + aAccount.userId)
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.adviser_box {
  margin-top: 0.72rem;
  .img_box {
    justify-content: center;
    width: 2.4rem;
    height: 2.4rem;
    background: #ffffff;
    border-radius: 0.16rem;
    box-shadow: 0rem 0rem 0.22rem 0rem rgba(0, 0, 0, 0.1);
    img {
      display: block;
      width: 2rem;
    }
  }
  .text {
    padding-left: 10px;
    flex-shrink: 0;
    flex: auto;
    height: 1.48rem;
    line-height: 1.48rem;
    background: #ebf3f3;
    font-size: 0.32rem;
    color: #436f70;
    font-weight: 600;
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
  }
}
.m_box {
  font-size: 0.28rem;
  color: #000;
  margin-bottom: 5px;
  font-weight: 600;
  span {
    text-decoration: underline;
    text-decoration-color: #00b25a;
  }
}
.list {
  .info_weight {
    color: #000;
  }
  img {
    display: block;
  }

  .list_item {
    position: relative;
    border-radius: 0.16rem;
    box-shadow: 0rem 0rem 0.2rem 0rem rgba(0, 0, 0, 0.1);
    margin-top: 0.48rem;
    padding: 0.24rem;
    color: #999999;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.1);
    .label {
      position: absolute;
      top: -1px;
      right: -1px;
      z-index: 3;
      border-bottom-left-radius: 0.16rem;
      padding: 0.12rem;
      font-size: 0.24rem;
    }
    .recommend {
      background-color: #00b25a;
      color: #fff;
    }
    .disRecommend {
      color: #c35151;
      background: #f8dada;
    }
    .item_top {
      align-items: flex-start;
      img {
        flex-shrink: 0;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        margin-right: 0.24rem;
      }
      .user {
        width: calc(60% - 0.2rem);
        h3 {
          font-size: 0.32rem;
          font-weight: 600;
          color: #000000;
          margin-bottom: 0.16rem;
          width: 100%;
          word-break: keep-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .info {
          font-size: 0.24rem;
          margin-top: 0.12rem;
        }
      }
      .no_user {
        width: calc(60% - 0.6rem);
      }
    }
    .cell_title {
      font-size: 0.28rem;
      margin-top: 0.4rem;
      .flexbox {
        margin-left: 0.16rem;
      }
      img {
        width: 0.28rem;
        height: 0.28rem;
      }
    }
    .cell {
      margin-top: 0.32rem;
      transition: all 0.5s linear;
      p {
        font-size: 0.24rem;
        color: #666666;
        margin-top: 0.16rem;
      }
    }
  }
  .actClass {
    background-color: #fff !important;
    border-color: #00b25a !important;
    color: #000000 !important;
  }
}
</style>
